import { useState, useEffect, useRef } from "react";

const INITIAL_FORM_DATA = {
  firstName: "",
  lastName: "",
  companyName: "",
  country: "",
  address: "",
  apartment: "",
  city: "",
  state: "",
  zipCode: "",
  phone: "",
  email: "",
};

const REQUIRED_FIELDS = ["firstName", "lastName", "country", "address", "city", "zipCode", "phone", "email"];

export default function useCheckoutForm() {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [fieldErrors, setFieldErrors] = useState({});
  const formDataRef = useRef(formData);

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateFields = () => {
    const errors = {};
    REQUIRED_FIELDS.forEach(field => {
      if (!formData[field] || formData[field].trim() === "") {
        errors[field] = true;
      }
    });
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = true;
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    const allFilled = REQUIRED_FIELDS.every(field => formData[field] && formData[field].trim() !== "");
    const emailValid = !formData.email || /\S+@\S+\.\S+/.test(formData.email);
    return allFilled && emailValid;
  };

  return { formData, setFormData, formDataRef, fieldErrors, setFieldErrors, handleInputChange, validateFields, isFormValid };
}
